<template>
  <div>
    <div class="row" v-show="imgSrc === null && oldImage === null">
      <v-file-input
          truncate-length="15"
          v-bind:label="$t('Signature')"
          @click.prevent="showFileChooser"
      ></v-file-input>
    </div>
    <div class="row" v-show="imgSrc !== null || oldImage !== null">
      <div class="col col-10">
        <vue-cropper
            ref="cropper"
            v-show="imgSrc"
            :src="imgSrc"
            alt="Signature Image"
            :containerStyle="{'height': '300px'}"
            @cropend="cropImage"
            :ready="test"
        >
        </vue-cropper>

        <section class="preview-area" v-if="!imageHasChanged">
          <div class="cropped-image">
            <v-img
                :src="oldImage"
                max-height="300"
                max-width="300"
                contain
            ></v-img>
          </div>
        </section>
      </div>
      <div class="col col-auto">
        <v-row class="mb-2">
          <v-btn icon @click.prevent="showFileChooser">
            <v-icon>mdi-file-upload</v-icon>
          </v-btn>
        </v-row>
        <v-row v-show="imgSrc">
          <v-btn icon @click.prevent="rotate(90)">
            <v-icon>mdi-rotate-left</v-icon>
          </v-btn>
        </v-row>
        <v-row v-show="imgSrc">
          <v-btn icon @click.prevent="rotate(-90)">
            <v-icon>mdi-rotate-right</v-icon>
          </v-btn>
        </v-row>
        <v-row v-show="imgSrc">
          <v-btn icon ref="flipX" @click.prevent="flipX" data-scale="1">
            <v-icon>mdi-flip-horizontal</v-icon>
          </v-btn>
        </v-row>
        <v-row v-show="imgSrc">
          <v-btn icon ref="flipY" @click.prevent="flipY" data-scale="1">
            <v-icon>mdi-flip-vertical</v-icon>
          </v-btn>
        </v-row>

        <input
            ref="input"
            hidden="hidden"
            type="file"
            name="image"
            accept="image/*"
            @change="setImage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import 'cropperjs/dist/cropper.css';

export default {
  components: {VueCropper},
  name: "ImageCropper",
  props: {
    onChange: Function,
    oldImage: String
  },
  mounted() {
    this.reset();
  },
  data() {
    return {
      imgSrc: null,
      imageHasChanged: false
    }
  },
  methods: {
    setImage(e) {
      let file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
        this.imageHasChanged = true;
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    test(a,b,c) {
      console.log("TEST");
      this.cropImage();
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    cropImage() {
      this.onChange(this.$refs.cropper.getCroppedCanvas().toDataURL());
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    flipX() {
      const dom = this.$refs.flipX.$el;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY.$el;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    reset() {
      this.imgSrc = null;
      this.$refs.cropper.replace(null);
      this.imageHasChanged = false;
    }
  }
}
</script>